import React, {Component} from 'react';
import PropTypes from "prop-types";
import classnames from 'classnames';
import './notifications.scss'

import notificationService from './notificationService';

const classToIcons = {
  info: 'ss-info',
  success: 'ss-checkcircle',
  warning: 'ss-alertcirle'
};

class Notification extends Component {
  constructor(props){
    super(props);
    this.onLinkClicked = this.onLinkClicked.bind(this);
    this.onNotificationDismiss = this.onNotificationDismiss.bind(this);
  }

  classFromType(){
    switch (this.props.type){
      case Notification.Types.INFO:
      case Notification.Types.WARNING:
      case Notification.Types.SUCCESS:
        return this.props.type;
      default:
        return Notification.Types.SUCCESS;
    }
  }

  onLinkClicked(){
    const {onLinkClick} = this.props;
    switch(typeof onLinkClick){
      case 'string':
        window.location.hash = onLinkClick;
        break;
      case 'function':
        onLinkClick();
        break;
      default:
        //do nothing
    }
    this.onNotificationDismiss();
  }

  onNotificationDismiss(){
    notificationService.removePopup();
  }

  render(){
    const { type, text, linkText, onLinkClick } = this.props;
    const classFromType = this.classFromType();
    const notificationClasses = {
      "cm-popup": true,
      [`popup-${classFromType}`]: true
    };
    const iconClasses = {
      "ss-icon": true,
      [classToIcons[classFromType]]: true
    };

    let linkDisplay;
    if(linkText){
      linkDisplay = (
        <span className="popup-link clickable" onClick={this.onLinkClicked}>
          {linkText}
        </span>
      );
    }


    return (
      <div className={classnames(notificationClasses)}>
        <div className="icon-container">
          <div className={classnames(iconClasses)} />
        </div>
        <div className="message-container">
          <div className="popup-dismiss clickable ss-icon ss-delete" onClick={this.onNotificationDismiss} />
          {text}
          {linkDisplay}
        </div>
      </div>
    );
  }
}

Notification.propTypes = {
  type: PropTypes.string,
  text: PropTypes.string.isRequired,
  linkText: PropTypes.string,
  // either link or action
  onLinkClick: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ])
};

Notification.Types = {
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning'
};


export default Notification;

